// 后端微服务端口名
export const PORT1 = ''
export const PORT2 = '/user'
export const ORDER = '/order'
export const ADMIN = '/admin'

